import type { IPageAnalyticMapping } from '../../modules/analytic/types';

import { usePageAnalyticDetailContext } from '../../contexts/PageAnalyticDetailProvider';
import { PACardLineChart } from '../../modules/analytic';
import { useAnalyticData } from '~/core/gemxql/hooks';
import { EMetricKey } from '~/types/metric';
import { Grid } from '@shopify/polaris';

const ANALYTICS_DATA_SECOND: IPageAnalyticMapping[] = [
  { key: EMetricKey.AVG_TIME_ON_PAGE, title: 'Avg time on page' },
  { key: EMetricKey.PAGE_VIEWS, title: 'Pageviews' },
  { key: EMetricKey.RPV, title: 'Revenue per visitor' },
];
export const PageAnalyticGridLine = () => {
  const { totalsRow, comparisonTotalsRow, columnTypes, isLoading } = usePageAnalyticDetailContext();
  const { computeMetric } = useAnalyticData();

  return (
    <Grid gap={{ xs: '200' }}>
      {ANALYTICS_DATA_SECOND.map(({ key, title }) => (
        <Grid.Cell
          key={key}
          columnSpan={{
            xs: 6,
            lg: 4,
          }}
        >
          <PACardLineChart
            title={title}
            metricKey={key}
            control={computeMetric({
              metric: totalsRow,
              previousMetric: comparisonTotalsRow,
              metricKey: key,
              formatter: columnTypes?.[key],
            })}
            isLoading={isLoading}
          />
        </Grid.Cell>
      ))}
    </Grid>
  );
};
